module.exports = __webpack_public_path__ + "static/media/CC5-1.0f53a63b.jpg";